module.exports = __webpack_public_path__ + "static/open-account-frame-update-b7c05d3ae9c6647faa98072cf9754ba1.png";